import api from 'service/api'

const dponetAPI = api.create('dponet')

const contactSpecialistRdStation = async ({ ticket }) =>
  await dponetAPI.post('/rd_station/contact_specialist', {
    ticket,
  })

export default {
  contactSpecialistRdStation,
}
